/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2024, Zumper
 */

export const GCLID_LOCAL_STORAGE_KEY = '_xgclid'
export const MSCLKID_LOCAL_STORAGE_KEY = '_xmsclkid'
